import { FC } from "react";
import { CollectionIcon } from "@/components/collection/CollectionIcon";
import { MDSTextOverflow, MDSTextWeight, MDSTextVariant, MDSTextColor } from "@/mds";
import { StyledChip, StyledIconContainer, StyledLabelText } from "@/components/chips/chip.style";

interface CollectionChipProps {
  id?: string;
  label?: string;
  inline?: boolean;
}

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export const CollectionChip: FC<CollectionChipProps> = ({ id, label, inline }) => {
  return (
    <StyledChip $inline={inline}>
      <StyledIconContainer $inline={inline}>
        <CollectionIcon size={16} collectionId={id} legacy={false} />
      </StyledIconContainer>
      <StyledLabelText
        $inline={inline}
        variant={MDSTextVariant.HeaderL}
        weight={MDSTextWeight.SemiBold}
        color={MDSTextColor.Contrast}
        overflow={MDSTextOverflow.Ellipsis}
      >
        {label}
      </StyledLabelText>
    </StyledChip>
  );
};
